'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import type { CategoriesEntity } from '@eliadmin/core/src/api/general/types/general-layout-types';
import type { Service } from '@eliadmin/core/src/api/slugs/types/slug-detail-types';

import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetTrigger,
} from '@eliadmin/core/src/components/ui/sheet';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { getSafeHref } from '@eliadmin/core/src/utils/url-utils';
import { LuMenu } from 'react-icons/lu';
import { LanguageSelect } from './language-select';

export type MobileSidebarProps = {
  className?: {
    trigger?: string;
    content?: string;
    firstSeparator?: string;
    menuList?: string;
    menuLink?: string;
    menuGroup?: string;
    menuSeparator?: string;
    buttonWrapper?: string;
    button?: string;
    iconsWrapper?: string;
    icon?: string;
  };
  side?: 'right' | 'left' | 'bottom' | 'top';
  firstSeparator?: boolean;
  therapies?: Service[];
  menu?: {
    type: 'page';
    name: string;
    path?: string;
  }[];
  menuArrow?: boolean;
  menuSeparator?: boolean;
  categories?: CategoriesEntity[];
};

const MobileSidebar = (props: MobileSidebarProps) => {
  return (
    <>
      <Sheet>
        <SheetTrigger
          aria-label="Menu"
          className={cn('text-muted', 'ea-mobile-sidebar__trigger', props.className?.trigger)}
        >
          <LuMenu size={24} />
        </SheetTrigger>
        <SheetContent
          hideOverlay
          side={props.side}
          className={cn(
            'flex h-full w-full max-w-[640px] flex-col items-start justify-between border-none bg-white p-0 shadow-none sm:max-w-[640px]',
            'h-[calc(100vh-58px)]',
            'ea-mobile-sidebar__content',
            props.className?.content,
          )}
          closeIcon={{
            wrapper: 'hidden',
          }}
        >
          <div className="w-full flex-col items-start justify-start">
            <div className="w-full p-4">
              <SheetClose className="flex items-center justify-center">
                <Image
                  src={'/images/icons/close-square-dark.svg'}
                  alt="Close"
                  width={0}
                  height={0}
                  className="max-h-6 min-h-6 min-w-6 max-w-6"
                />
              </SheetClose>
            </div>
            <div className="flex flex-col items-start justify-start gap-6 px-4 py-6">
              {props.menu &&
                props.menu.map(item => (
                  <SheetClose asChild key={item.name}>
                    <Link prefetchOnHover
                      prefetch={false}
                      href={getSafeHref(item?.path ?? '#')}
                      className={cn('font-semibold uppercase text-black', 'h4')}
                    >
                      {item.name}
                    </Link>
                  </SheetClose>
                ))}
            </div>
          </div>
          <div className="w-full px-4 pb-6">
            <LanguageSelect />
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
};

export default MobileSidebar;
